import { render, staticRenderFns } from "./dashboard-password.vue?vue&type=template&id=6a32feba&"
import script from "./dashboard-password.vue?vue&type=script&lang=js&"
export * from "./dashboard-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports